import {CSSProperties} from '../../../styleSheet';
import {BaseFontProps} from '../types';

export const buildFontStyle = ({
  fontFamily,
  fontSizePx,
  lineHeightPx,
  fontWeight,
}: BaseFontProps = {}): CSSProperties => ({
  ...(fontFamily ? {fontFamily: fontFamily} : {}),
  ...(fontSizePx ? {fontSize: `${fontSizePx}px`} : {}),
  ...(lineHeightPx ? {lineHeight: `${lineHeightPx}px`} : {}),
  ...(fontWeight ? {fontWeight: fontWeight} : {}),
});
